// extracted by mini-css-extract-plugin
export var editButton = "detailsPage-module--edit-button--56f2c";
export var gridAriane = "detailsPage-module--grid-ariane--5012f";
export var gridContent = "detailsPage-module--grid-content--09b92";
export var gridResume = "detailsPage-module--grid-resume--b3483";
export var gridTags = "detailsPage-module--grid-tags--8b27f";
export var gridTitle = "detailsPage-module--grid-title--68e09";
export var pageAdditionalInfos = "detailsPage-module--page-additional-infos--0936c";
export var pageBase = "detailsPage-module--page-base--f4e45";
export var pageContentFooter = "detailsPage-module--page-content-footer--b19ee";
export var pageContentFooterBack = "detailsPage-module--page-content-footer-back--31973";
export var pageImg = "detailsPage-module--page-img--f2bdf";
export var pageTitle = "detailsPage-module--page-title--55bf0";